export default __webpack_public_path__ + "71387ffe224047aef5479f8f5f32c07c.png";